import ToolTip from "@components/Tooltip";
import {
  ColorInput as MantineColorInput,
  FileInput as MantineFileInput,
  PasswordInput as MantinePasswordInput,
  TextInput,
  Textarea,
} from "@mantine/core";
import { RiEye2Line, RiEyeCloseLine } from "react-icons/ri";
import "./style.css";

const InputWrapper = ({
  label,
  id,
  name,
  onChange,
  value,
  placeholder,
  labelClassName,
  error,
  inputClassName,
  size,
  type,
  isTooltip,
  toolTipContent,
  divclassname,
  withAsterisk,
  description,
  disabled,
  inputType = "default", // 'default' | 'l-i'
  ...restProps
}) => {
  return inputType === "l-i" ? (
    <>
      <div
        className={`input-wrapper  gap-2 ${
          divclassname || "mb-1"
        } lg:flex items-center`}
      >
        <label className={labelClassName || "text-gray-600 font-semibold"}>
          {isTooltip ? (
            <div className='flex items-center gap-1'>
              {label}
              <ToolTip toolTipContent={toolTipContent} />
            </div>
          ) : (
            label
          )}
        </label>
        <TextInput
          variant='unstyled'
          className={inputClassName || "mt-1 border-b-2 flex-1"}
          styles={{
            input: {
              // paddingTop: "12px",
              fontSize: "14px",
            },
          }}
          // error={error ?? null}
          withAsterisk={withAsterisk}
          description={description}
          name={name}
          size={size}
          onChange={onChange}
          value={value || ""}
          placeholder={placeholder}
          type={type}
          id={id}
          disabled={disabled}
          {...restProps}
        />
      </div>
      <div className='gap-4 flex items-center mb-4'>
        <div className={` inline-block ${labelClassName}`}></div>
        <label className='text-red-500 text-xs'>{error}</label>
      </div>
    </>
  ) : (
    <TextInput
      label={
        label ? (
          toolTipContent ? (
            <span className='inline-flex items-center gap-1'>
              {label}
              <ToolTip toolTipContent={toolTipContent} />
            </span>
          ) : (
            <span className={labelClassName}>{label}</span>
          )
        ) : null
      }
      className={divclassname || "w-full md:w-1/2 mb-4"}
      error={error ?? null}
      withAsterisk={withAsterisk}
      description={description}
      name={name}
      inputClassName={inputClassName}
      size={size}
      onChange={onChange}
      value={value || ""}
      placeholder={placeholder}
      type={type}
      id={id}
      disabled={disabled}
      {...restProps}
    />
  );
};

export default InputWrapper;

export const PasswordInput = ({
  label,
  id,
  name,
  onChange,
  value,
  placeholder,
  className,
  error,
  ...restProps
}) => {
  return (
    <>
      <MantinePasswordInput
        label={label}
        id={id}
        name={name}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        className={className}
        error={error}
        visibilityToggleIcon={({ reveal }) =>
          reveal ? <RiEyeCloseLine /> : <RiEye2Line />
        }
        {...restProps}
      />
    </>
  );
};

export const ColorInput = ({
  label,
  description,
  placeholder,
  onChange,
  value,
  ...restProps
}) => {
  return (
    <MantineColorInput
      label={label}
      description={description}
      placeholder={placeholder}
      onChange={onChange}
      value={value || ""}
      {...restProps}
    />
  );
};

export const FileInput = ({ divclassname, ...props }) => {
  return (
    <MantineFileInput
      className={divclassname || "w-full md:w-1/2 mb-4"}
      {...props}
    />
  );
};

export const TextArea = ({
  label,
  id,
  name,
  onChange,
  value,
  placeholder,
  className,
  error,
  ...restProps
}) => {
  return (
    <Textarea
      label={label}
      id={id}
      name={name}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      className={className}
      error={error}
      {...restProps}
    />
  );
};
